import { isDevMode } from '@sportworld/js-sdk/src/envs/envs'

import { fireosKeys } from '@/constants/keys'

const modelYearList = {
  2022: [
    'AFTHA004',
    'AFTLBT962E2',
    'AFTTIFF43',
    'AFTGAZL',
    'AFTANNA0',
    'AFTHA001',
    'AFTMON001',
  ],
  2021: [
    'AFTJULI1',
    'AFTANNA0',
    'AFTHA003',
    'AFTKA',
    'AFTLFT962X3',
    'AFTTIFF43',
    'AFTTI43',
    'AFTHA001',
    'AFTHA002',
  ],
  2020: [
    'AFTPR001',
    'AFTBU001',
    'AFTWMST22',
    'AFTTIFF55',
    'AFTWI001',
    'AFTSSS',
    'AFTSS',
    'AFTDCT31',
    'AFTBAMR311',
  ],
  2019: [
    'AFTT',
    'AFTKMST12',
    'AFTMM',
    'AFTLE',
    'AFTR',
    'AFTEUFF014',
    'AFTEU014',
    'AFTSO001',
    'AFTMM',
    'AFTEU011',
  ],
  2017: ['AFTJMST12', 'AFTA', 'AFTMM', 'AFTT', 'AFTRS', 'AFTN'],
  2015: ['AFTS'],
  2014: ['AFTM', 'AFTB'],
}
const detectModelYear = (model: string) => {
  for (const [key, value] of Object.entries(modelYearList)) {
    if (value.indexOf(model) != -1) {
      return key
    }
  }
  return ''
}
const totalMemoryList = {
  1: [
    'AFTBU001',
    'AFTTIFF55',
    'AFTBAMR311',
    'AFTEAMR311',
    'AFTLE',
    'AFTSSS',
    'AFTSS',
    'AFTT',
    'AFTM',
  ],
  1.5: ['AFTPR001', 'AFTWMST22', 'AFTEU011', 'AFTMM'],
  2: [
    'AFTWI001',
    'AFTDCT31',
    'AFTKMST12',
    'AFTEUFF014',
    'AFTEU014',
    'AFTSO001',
    'AFTJMST12',
    'AFTLFT962X3',
    'AFTGAZL',
    'AFTR',
    'AFTA',
    'AFTKA',
    'AFTN',
    'AFTS',
    'AFTB',
  ],
  3: ['AFTRS'],
  4: ['AFTMON001', 'AFTLBT962E2'],
}
const detectTotalMemory = (model: string) => {
  for (const [key, value] of Object.entries(totalMemoryList)) {
    if (value.indexOf(model) != -1) {
      return (+key * 1024).toString()
    }
  }
  return '0'
}
export default class FireosPlatform {
  name: string
  appBundle: string
  keys: { [key: string]: number }
  duid: string
  uuid: string
  manufacturer
  modelCode: string
  modelName: string
  modelYear: string
  version: string
  totalMemory: string
  constructor() {
    this.name = 'FireOS'
    this.appBundle = ''
    this.keys = fireosKeys
    this.duid = ''
    this.uuid = ''
    this.manufacturer = 'Amazon'
    this.modelCode = ''
    this.modelName = ''
    this.modelYear = ''
    this.version = '0'
    this.totalMemory = '0'
    this.init()
  }
  init() {
    isDevMode && console.log('[platform] init', this.name)
    const initProps = () => {
      this.setDuid()
      this.setUuid()
      this.setModelProps()
    }
    document.addEventListener('deviceready', initProps, false)
  }
  setDuid() {
    this.duid = window.device.serial
  }
  setUuid() {
    this.uuid = window.device.uuid
  }
  reloadApp() {
    return undefined
  }
  closeApp() {
    window.open('', '_self')?.close()
  }
  setModelProps() {
    this.modelCode = window.device.model
    this.modelName = window.device.model
    this.modelYear = detectModelYear(window.device.model)
    if (window.device.version === '5.1') {
      this.version = '5'
    } else if (window.device.version === '7.1') {
      this.version = '6'
    } else if (window.device.version === '9') {
      this.version = '7'
    }
    this.totalMemory = detectTotalMemory(window.device.model)
  }
  getDuid() {
    return this.duid
  }
  getUuid() {
    return this.uuid
  }
  getIfa() {
    return this.duid
  }
  /**
   * Checks whether the device has limited ad tracking.
   *
   * @returns boolean value value to indicate whether limited ad tracking is set.
   * - true: Limit Ad Tracking
   * - false: Not Limit Ad Tracking
   */
  getLat() {
    return false
  }
  getVersion() {
    return this.version
  }
  getWidgetVersion() {
    return undefined
  }
  getModelCode() {
    return this.modelCode
  }
  getModelName() {
    return this.modelName
  }
  getModelYear() {
    return this.modelYear
  }
  getAppBundleName() {
    return this.appBundle
  }
  isChannelTunable() {
    return false
  }
  tuneToChannel() {}
  deepLinkToPromotion() {}
  deepLinkToAppId() {}
  getTotalMemory() {
    return this.totalMemory
  }
  getAvailableMemory() {
    return undefined
  }
  openAppStorePage() {
    isDevMode && console.log('[fireos] openAppStorePage')
    return undefined
  }
}
